var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarePlanIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 8.00008V6.33341C1.66699 3.83341 3.33366 2.16675 5.83366 2.16675H14.167C16.667 2.16675 18.3337 3.83341 18.3337 6.33341V8.00008",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 8.00008V6.33341C1.66699 3.83341 3.33366 2.16675 5.83366 2.16675H14.167C16.667 2.16675 18.3337 3.83341 18.3337 6.33341V8.00008",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 13V14.6667C1.66699 17.1667 3.33366 18.8333 5.83366 18.8333H14.167C16.667 18.8333 18.3337 17.1667 18.3337 14.6667V13",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58301 8.2168L9.99968 10.7751L14.383 8.23348",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.3085V10.7668",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96685 5.74155L6.30019 7.22491C5.70019 7.55824 5.2002 8.3999 5.2002 9.09157V11.9166C5.2002 12.6082 5.69186 13.4499 6.30019 13.7832L8.96685 15.2665C9.53352 15.5832 10.4669 15.5832 11.0419 15.2665L13.7085 13.7832C14.3085 13.4499 14.8085 12.6082 14.8085 11.9166V9.09157C14.8085 8.3999 14.3169 7.55824 13.7085 7.22491L11.0419 5.74155C10.4669 5.41655 9.53352 5.41655 8.96685 5.74155Z",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlanIcon);
export default __webpack_public_path__ + "static/media/care_plan_icon.17645b1a2eb307b5a4778e3a8c05fa3d.svg";
export { ForwardRef as ReactComponent };